import React from "react";

export default class BlockHowToGuidesJunkRemoval extends React.Component  
{
    
    render()
    {
        return (
            <div className="how-to-guides">
                <h2>How-To Articles</h2>
                <div className="provider-card">    
                    <div className="items-list">
                        <a href={'/blog/junk-removal-101'} className="item">
                            <div className="item-text">
                                <h5>GETTING STARTED</h5>
                                <h6>Junk removal 101 begins</h6>
                            </div>
                        </a>
                        <a href={'/blog/how-much-does-it-cost-to-haul-away-junk'} className="item">
                            <div className="item-text">
                                <h5>COST</h5>
                                <h6>Learn how to get the best price</h6>
                            </div>
                        </a>
                        <a href={'/blog/on-site-junk-removal'} className="item">
                            <div className="item-text">
                                <h5>ESTIMATES</h5>
                                <h6>Know what to expect from on-site quotes</h6>
                            </div>
                        </a>
                        <a href={'/blog/how-cleanout-services-work'} className="item">
                            <div className="item-text">
                                <h5>CLEANOUTS</h5>
                                <h6>Understand how cleanout services work</h6>
                            </div>
                        </a>
                        <a href={'/blog/rent-a-dumpster-or-hire-a-junk-removal-company'} className="item">
                            <div className="item-text">
                                <h5>OPTIONS</h5>
                                <h6>Hire junk removal or rent a dumpster</h6>
                            </div>
                        </a>
                        <a href={'/blog/diy-vs-professional-junk-removal-which-option-is-right-for-you'} className="item">
                            <div className="item-text">
                                <h5>DIY</h5>
                                <h6>Compare DIY junk removal to hiring the pros</h6>
                            </div>
                        </a>
                    </div>                    
                </div>
            </div>
        )
    }
};